<template>
    <panel no-button="true">
        <!-- begin panel-heading -->
        <template slot="header">
            <h4 class="panel-title" v-if="item">Edit {{ item.name }}</h4>
        </template>
        <p v-if="errors.length">Please correct the following error(s): </p>
        <ul>
            <li v-for="error in errors" :key="error" style="color: red"> {{ error}} </li>
        </ul>
        <!-- end panel-heading -->
        <form v-if="item">
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Name</label>
                <div class="col-md-9">
                    <input v-model="name" type="text" class="form-control m-b-5" placeholder="Enter item name" />
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">{{ mainCategoryValue }}</label>
                <div class="col-md-9">
                    <select v-model="mainCategoryId" class="form-control" @change="getSubcategories()">
                        <option value="0" disabled>Select {{ mainCategoryValue }}</option>
                        <option v-for="category in getCategories" :key="category.id" :value="category.id">{{ category.name }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">{{ subcategoryValue }}</label>
                <div class="col-md-9">
                    <select v-model="categoryId" class="form-control">
                        <option value="0" disabled>Select {{ subcategoryValue }}</option>
                        <option v-for="category in subcategories" :key="category.id" :value="category.id">{{ category.name }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Unit</label>
                <div class="col-md-9">
                    <select v-model="unit" class="form-control">
                        <option value="pcs">Pieces</option>
                        <option v-if="this.$route.params.type == 'stuff'" value="m">Metres</option>
                    </select>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Number of {{ amountLabel }}</label>
                <div class="col-md-9">
                    <input v-model="amount" type="number" min="0" class="form-control m-b-5" placeholder="Enter amount" />
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Unit price</label>
                <div class="col-md-9">
                    <input v-model="unitPrice" type="number" min="0" step="0.01" class="form-control m-b-5" placeholder="Enter unit price" />
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Source</label>
                <div class="col-md-9">
                    <select v-model="source" class="form-control">
                        <option value="None">None</option>
                        <option value="Owned">Owned</option>
                        <option value="Contract">Contract</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Description</label>
                <div class="col-md-9">
                    <textarea v-model="description" class="form-control" rows="3" />
                </div>
            </div>
            <div v-for="(note, index) in notes" :key="index" class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Note #{{ index + 1 }}</label>
                <div class="col-md-8">
                    <textarea v-model="note.content" class="form-control" rows="3" />
                </div>
                <div class="col-md-1">
                    <b-button @click="openModal(index)" class="btn-danger pull-right">Remove note</b-button>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <div class="col-md-11"/>
                <div class="col-md-1">
                    <input-button type="button" label="Add note" @click="addNote" class="btn-inverse pull-right" />
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Picture</label>
                <div class="col-md-9">
                    <vue-dropzone ref="imageDropzone" id="imageDropzone" :options="imageDropzoneOptions" @vdropzone-removed-file="imageRemoved" @vdropzone-success="imageSuccess" />
                    <b-button variant="yellow" class="mt-2" @click="openImageLibrary">Choose from library</b-button>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Additional files</label>
                <div class="col-md-9">
                    <vue-dropzone ref="filesDropzone" id="filesDropzone" :options="filesDropzoneOptions" @vdropzone-removed-file="fileRemoved" @vdropzone-success="fileSuccess" />
                </div>
            </div>
        </form>
        <hr/>

        <b-button variant="secondary" @click="cancel">Cancel</b-button>
        <input-button type="submit" label="Save" @click="validate" class="submit btn-yellow pull-right" />
        
        <b-modal ref="modalAlert" :title="'Delete Note #' + (currentIndex + 1)" centered cancel-variant="white" ok-variant="danger" ok-title="Delete" v-on:ok="removeNote(currentIndex)">
            <div class="alert alert-danger m-b-0">
                <h5><i class="fa fa-info-circle"></i>Delete</h5>
                <p>Are you sure you want to delete Note #{{ currentIndex + 1}}?</p>
            </div>
        </b-modal>

        <image-library-modal ref="childModal" />
    </panel>
</template>

<script>
import InputButton from '../buttons/InputButton.vue'
import ImageLibraryModal from '../image-library/ImageLibraryModal.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { authHeader } from '../../helpers'

export default {
    name: 'ItemEdit',
    props: ['typeId', 'item', 'categories'],
    data() {
        return {
            mainCategoryValue: 'Service category',
            subcategoryValue: 'Service area',
            amountLabel: 'items',
            errors: [],
            name: null,
            mainCategoryId: 0,
            subcategories: [],
            categoryId: 0,
            source: 'None',
            unit: 'pcs',
            amount: null,
            unitPrice: null,
            description: '',
            notes: [],
            currentIndex: 0,
            imageId: null,
            fileIds: [],
            imageChanged: false,
            filesChanged: false,
            dropzoneArray: [],
            imageDropzoneOptions: {
                url: process.env.VUE_APP_API_URL + '/image',
                thumbnailSize: 175,
                addRemoveLinks: true,
                maxFiles: 1,
                maxFilesize: 2,
                acceptedFiles: 'image/jpg, image/jpeg, image/png',
                dictDefaultMessage: 'Drop an image here or click to upload',
                headers: authHeader()
            },
            filesDropzoneOptions: {
                url: process.env.VUE_APP_API_URL + '/file',
                thumbnailWidth: 175,
                addRemoveLinks: true,
                maxFilesize: 5,
                acceptedFiles: 'application/pdf, image/jpg, image/jpeg',
                dictDefaultMessage: 'Drop files here or click to upload',
                headers: authHeader()
            },
            isDestroying: false
        }
    },
    components: {
        InputButton,
        ImageLibraryModal,
        VueDropzone: vue2Dropzone
    },
    computed: {
        getCategories() {
            let self = this;
            let mainCategories = [];
            switch (this.typeId) {
                case 1:
                    self.itemType = 'service';
                    self.mainCategoryValue = 'Service category';
                    self.subcategoryValue = 'Service area';
                    self.amountLabel = 'items';
                    break;
                case 2:
                    self.itemType = 'space';
                    self.mainCategoryValue = 'Venue';
                    self.subcategoryValue = 'Area';
                    self.amountLabel = 'items';
                    break;
                case 3:
                    self.itemType = 'staff';
                    self.mainCategoryValue = 'Group';
                    self.subcategoryValue = 'Team';
                    self.amountLabel = 'persons';
                    break;
                case 4:
                    self.itemType = 'stuff';
                    self.mainCategoryValue = 'Stuff category';
                    self.subcategoryValue = 'Stuff subcategory';
                    self.amountLabel = 'items';
                    break;
                default:
                    break;
            }
            this.categories.forEach(category => {
                if (category.type.id == this.typeId) {
                    if (!category.parent) {
                        mainCategories.push(category);
                    }
                }
            });
            this.getSubcategories();
            return mainCategories;
        }
    },
    methods: {
        getSubcategories() {
            this.categoryId = 0;
            this.subcategories = [];
            this.categories.forEach(category => {
                if (this.mainCategoryId) {
                    if (category.parent && category.parent.id == this.mainCategoryId) {
                        this.subcategories.push(category);
                    }
                } else {
                    if (category.parent && category.type.id == this.typeId) {
                        this.subcategories.push(category);
                    }
                }
            });
            if (this.item.category) {
                this.categoryId = this.item.category.id;
            }
        },
        addNote() {
            this.notes.push({ content: '' })
        },
        openModal(index) {
            this.currentIndex = index;
            this.$refs['modalAlert'].show();
        },
        removeNote(index) {
            if (this.notes[index].id) {
                this.$parent.deleteNoteCall(this.notes[index].id)
            }
            this.notes.splice(index, 1);
        },
        imageRemoved() {
            if (!this.isDestroying) {
                this.$parent.removeImage(this.imageId);
                this.imageId = null;
            }
        },
        imageSuccess(imageFile, image) {
            this.imageId = image.id;
            this.imageChanged = true;
        },
        imageSelected(image) {
            this.$refs.imageDropzone.removeAllFiles();
            this.imageId = image.id;

            let mockFile = {
                id: this.imageId,
                size: 175,
                url: process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
            }
            this.$refs.imageDropzone.manuallyAddFile(mockFile, mockFile.url);
        },
        openImageLibrary() {
            this.$refs['childModal'].$refs['modalImageLibrary'].show();
        },
        cancel() {
            if (this.imageChanged) {
                this.$parent.removeImage(this.imageId);
            }
            if (this.filesChanged) {
                this.fileIds.forEach(fileId => {
                    this.$parent.removeFile(fileId);
                });
            }
            this.$router.push(`/eventbank/${this.$route.params.type}/items/${this.item.id}`);
        },
        fileRemoved(file) {
            if (!this.isDestroying) {
                let index = 0;
                this.dropzoneArray.forEach(function(obj, objIndex) {
                    if (file.upload) {
                        if (file.upload.uuid == obj.upload.uuid) {
                            index = objIndex;
                        }
                    } else {
                        if (file.url == obj.url) {
                            index = objIndex;
                        }
                    }
                });
                this.dropzoneArray = this.$refs.filesDropzone.dropzone.files;
                this.$parent.removeFile(this.fileIds[index]);
                this.fileIds.splice(index, 1);
            }
        },
        fileSuccess(fileFile, file) {
            this.fileIds.push(file.id);
            this.dropzoneArray = this.$refs.filesDropzone.dropzone.files;
            this.filesChanged = true;
        },
        validate() {
            if (this.name && (this.amount >= 0 || !this.amount)) {
                if (!this.amount) {
                    this.amount = 0;
                }
                if (this.categoryId == 0) {
                    this.categoryId = null;
                }
                this.submit();
            }

            this.errors = [];

            if (!this.name) {
                this.errors.push("Name required!");
            }

            if (this.amount < 0) {
                this.errors.push("Amount cannot be a negative number!");
            }
        },
        submit() {
            this.notes.forEach(note => {
                if (note.id) {
                    this.$parent.submitNote(note.id, JSON.stringify({
                        content: note.content
                    }));
                } else {
                    this.$parent.createNoteCall(JSON.stringify({
                        content: note.content,
                        itemId: this.item.id
                    }));
                }
            });
            this.$parent.submit(this.item.id, JSON.stringify({
                name: this.name,
                categoryId: parseInt(this.categoryId),
                source: this.source,
                unit: this.unit,
                amount: parseInt(this.amount),
                unitPrice: this.unitPrice,
                description: this.description,
                imageId: this.imageId,
                fileIds: this.fileIds
            }));
        }
    },
    created() {
        this.$parent.getItemCall()
    },
    beforeDestroy() {
        this.isDestroying = true;
    },
    updated() {
        if (!this.name) {
            this.name = this.item.name
            if (this.item.category) {
                this.categoryId = this.item.category.id
            }
            this.source = this.item.source
            this.unit = this.item.unit
            this.amount = this.item.amount
            this.unitPrice = this.item.unitPrice
            this.description = this.item.description
            this.notes = this.item.notes
            if (this.item.image != null) {
                this.imageId = this.item.image.id;
            
                let mockFile = {
                    id: this.item.image.id,
                    size: 175,
                    url: process.env.VUE_APP_API_URL + '/uploads/images/' + this.item.image.imageFd
                }
                
                if (mockFile.id != null) {
                    this.$refs.imageDropzone.manuallyAddFile(mockFile, mockFile.url);
                }
            }
            if (this.item.files.length > 0) {
                this.fileIds = [];
                this.item.files.forEach(file => {
                    this.fileIds.push(file.id);

                    let mockFile = {
                        id: file.id,
                        size: 175,
                        url: process.env.VUE_APP_API_URL + '/uploads/files/' + file.fileFd
                    }

                    if (mockFile.id != null) {
                        this.$refs.filesDropzone.manuallyAddFile(mockFile, mockFile.url);
                    }
                });
                this.dropzoneArray = this.$refs.filesDropzone.dropzone.files;
            }
        }
    }
}
</script>